import { NATIVE_CURRENCY_ADDRESS } from '@mogul/shared';

import { getStarsAddress, isEqualAddresses } from '../smart-contract-utils';
import type { Listing } from './MogulMarketplace';

export const getIsTokenListing = <ListingT extends Listing>(
  listing: ListingT,
  tokenAddress: string,
) => {
  if (listing?.listingPrices?.length === 0) {
    return (
      !!listing.highestBidToken &&
      isEqualAddresses(listing.highestBidToken, tokenAddress)
    );
  }

  const ethListingTokenIndex = listing.listingPrices!.findIndex(listingPrice =>
    isEqualAddresses(listingPrice.listingToken, tokenAddress),
  );
  return ethListingTokenIndex !== -1;
};

export const getIsEthListing = <ListingT extends Listing>(
  listing: ListingT,
) => {
  return getIsTokenListing(listing, NATIVE_CURRENCY_ADDRESS);
};

export const getIsStarsListing = <ListingT extends Listing>(
  listing: ListingT,
) => {
  const starsAddress = getStarsAddress();
  return getIsTokenListing(listing, starsAddress);
};

export const getListingTokenPrice = (
  listing: Listing,
  listingTokenAddress: string,
) => {
  const ethListingTokenIndex = listing.listingPrices!.findIndex(listingPrice =>
    isEqualAddresses(listingPrice.listingToken, listingTokenAddress),
  );
  if (ethListingTokenIndex === -1) {
    return 0;
  }
  return listing.listingPrices![ethListingTokenIndex].price;
};

export const getListingEthPrice = <ListingT extends Listing>(
  listing: ListingT,
) => {
  return getListingTokenPrice(listing, NATIVE_CURRENCY_ADDRESS);
};

export const getListingStarsPrice = <ListingT extends Listing>(
  listing: ListingT,
) => {
  const starsAddress = getStarsAddress();
  return getListingTokenPrice(listing, starsAddress);
};
